import { gql } from 'graphql-request'

export const getDebtNotice = gql`
  query getDebtNotice($identifier: String!) {
    applications {
      debtNotice {
        debtNoticeListData(identifier: $identifier) {
          number
          dueDate
          linkPdf
        }
      }
    }
  }
`

export const getDebtNoticeFinancialResponsible = gql`
  query getDebtNoticeFinancialResponsible($identifier: String!) {
    applications {
      debtNotice {
        debtNoticeFinancialResponsibleListData(identifier: $identifier) {
          number
          dueDate
          linkPdf
        }
      }
    }
  }
`

export const registerDebtNoticeRead = gql`
  mutation registerDebtNoticeRead($input: DebtNoticeReadReceiptInput!) {
    applications {
      debtNotice {
        debtNoticeReadReceipt(input: $input) {
          success
        }
      }
    }
  }
`